import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, HeartHandshake } from "lucide-react";

/**
 * Reusable CTA block placed at the end of every WIM article.
 * Designed so the wording, links and accent can be updated centrally
 * (or passed as props for per-article overrides in the future).
 */
export default function ArticleCTA({
  eyebrow = "Inside Just Care Community",
  title = "Practical support, written agreements and real-world tools.",
  description = "JCC is a resource hub for independent care — not an agency. Choose the area that fits where you are right now.",
  primary = { label: "Pro Carer Office — for carers", to: "/pro-carer-circle", accent: "purple" },
  secondary = { label: "Family Care Office — for families", to: "/family-access", accent: "teal" },
}) {
  const primaryClass = primary?.accent === "teal" ? "btn-teal" : "btn-purple";
  const secondaryClass = secondary?.accent === "purple" ? "btn-purple" : "btn-teal";
  return (
    <section className="mt-16" data-testid="article-cta">
      <div className="rounded-3xl border border-slate-200 bg-surface p-8 md:p-10">
        <div className="overline text-teal mb-2">{eyebrow}</div>
        <h2 className="font-display text-2xl md:text-3xl font-semibold leading-snug">{title}</h2>
        <p className="mt-3 text-ink-muted leading-relaxed max-w-2xl">{description}</p>
        <div className="mt-6 flex flex-wrap gap-3">
          {primary && (
            <Link to={primary.to} className={primaryClass} data-testid="article-cta-primary">
              <ShieldCheck className="w-4 h-4" /> {primary.label} <ArrowRight className="w-4 h-4" />
            </Link>
          )}
          {secondary && (
            <Link to={secondary.to} className={secondaryClass} data-testid="article-cta-secondary">
              <HeartHandshake className="w-4 h-4" /> {secondary.label} <ArrowRight className="w-4 h-4" />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
